/** Level 1 spacing attribute codes (ETSI EN 300 706 table 26). */
export const C = {
  ALPHA_BLACK: 0x00,
  ALPHA_RED: 0x01,
  ALPHA_GREEN: 0x02,
  ALPHA_YELLOW: 0x03,
  ALPHA_BLUE: 0x04,
  ALPHA_MAGENTA: 0x05,
  ALPHA_CYAN: 0x06,
  ALPHA_WHITE: 0x07,
  FLASH: 0x08,
  STEADY: 0x09,
  END_BOX: 0x0a,
  START_BOX: 0x0b,
  NORMAL_SIZE: 0x0c,
  DOUBLE_HEIGHT: 0x0d,
  DOUBLE_WIDTH: 0x0e,
  DOUBLE_SIZE: 0x0f,
  MOSAIC_BLACK: 0x10,
  MOSAIC_RED: 0x11,
  MOSAIC_GREEN: 0x12,
  MOSAIC_YELLOW: 0x13,
  MOSAIC_BLUE: 0x14,
  MOSAIC_MAGENTA: 0x15,
  MOSAIC_CYAN: 0x16,
  MOSAIC_WHITE: 0x17,
  CONCEAL: 0x18,
  CONTIGUOUS: 0x19,
  SEPARATED: 0x1a,
  ESC: 0x1b,
  BLACK_BACKGROUND: 0x1c,
  NEW_BACKGROUND: 0x1d,
  HOLD_MOSAICS: 0x1e,
  RELEASE_MOSAICS: 0x1f,
} as const;

/** Colour index 0–7 → CSS colour (the eight pure RGB values). */
export const COLOURS = ['#000000', '#ff0000', '#00ff00', '#ffff00', '#0000ff', '#ff00ff', '#00ffff', '#ffffff'] as const;
export const COLOUR_NAMES = ['black', 'red', 'green', 'yellow', 'blue', 'magenta', 'cyan', 'white'] as const;
